import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';
import DatePicker from 'react-datepicker';
import getLocale from '../../i18n/getLocale';

class FlightsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      today: '0000-00-00',
      flights: [],
      totals: [],
      bases_list: [],
      date: null,
      date_start: null,
      date_finish: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.locale = getLocale();

    this.delete = this.delete.bind(this);
    this.searchFlights = this.searchFlights.bind(this);
    this.refreshFlights = this.refreshFlights.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  } 
  
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Setamos o state.date para a data de hoje
  componentWillMount () {
      var today = new Date().toISOString().slice(0,10);
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date: today_str});
      this.setState({date_start: today_str});
      this.setState({date_finish: today_str});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
    if (this.state.date_start === "") {
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');
      this.setState({date_start: today_str});
    }
    if (this.state.date_finish === "") {
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');
      this.setState({date_finish: today_str});
    }
  }

  refreshFlights(event) {
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      bases_id: this.state.bases_id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
            self.setState({flights: responseJson.data.bases});
            self.setState({totals: responseJson.data.totals});
            self.handleAlert(event.message, event.status, 'closed');
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  searchFlights(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      bases_id: this.state.bases_id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({flights: responseJson.data.bases});
          self.setState({totals: responseJson.data.totals});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      bases_id: this.state.bases_id,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({flights: responseJson.data.bases});
          self.setState({totals: responseJson.data.totals});
        }
      }).then(() => {
      var url = config.get('api') + '/bases/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({bases_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Bases lista */ }); /* Flights */ 
  }

  delete (event) {
    var flight_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Voos.ListaDeVoos.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/voo/' + flight_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshFlights(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Voos.ListaDeVoos.titulo}</h3>      
      <Link to="/voo/cadastrar" className="btn btn-warning pull-right"><i className="fa fa-pencil"></i> {this.locale.Voos.ListaDeVoos.botaoEditarStatus}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.searchFlights}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Voos.ListaDeVoos.formulario.DataInicial}:</label>
              <DatePicker value={this.state.date_start} onChange={this.handleChangeDatePicker.bind(this, 'date_start')} className="form-control" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Voos.ListaDeVoos.formulario.DataFinal}:</label>
              <DatePicker value={this.state.date_finish} onChange={this.handleChangeDatePicker.bind(this, 'date_finish')} className="form-control" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Voos.ListaDeVoos.formulario.Base}:</label>
              <Select
                className=""
                name="bases_id"
                value={this.state.bases_id}
                searchable={true}
                multi={true}
                placeholder={this.locale.Voos.ListaDeVoos.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'bases_id')}
                options={this.state.bases_list}
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.Voos.ListaDeVoos.formulario.botaoProcurarVoos}</button>
        </div>
      </form>
      <hr/>
      <table className="table table-bordered table-striped table-hover">
        <thead>
            <tr>
                <th className="table-totals-flights-style" colSpan="2">{this.locale.Voos.ListaDeVoos.tabela.EstatisticasDeVooEm(this.state.date_start, this.state.date_finish)} </th>
            </tr>
            <tr>
                <th>{this.locale.Voos.ListaDeVoos.tabela.Tipo}</th>
                <th>{this.locale.Voos.ListaDeVoos.tabela.Valor}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.TempoTotalDeAtraso}</td>
                <td>{this.state.totals ? this.state.totals['atraso_total'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Atrasados}</td>
                <td>{this.state.totals ? this.state.totals['atraso_qtd'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Pontuais}</td>
                <td>{this.state.totals ? this.state.totals['pontual_qtd'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.MediaTempo}</td>
                <td>{this.state.totals ? this.state.totals['atraso_media'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Operacoes}</td>
                <td>{this.state.totals ? this.state.totals['operacoes'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Coordenacao}</td>
                <td>{this.state.totals ? this.state.totals['coordenacao'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Despacho}</td>
                <td>{this.state.totals ? this.state.totals['despacho'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Manutencao}</td>
                <td>{this.state.totals ? this.state.totals['manutencao'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.NumeroVoos}</td>
                <td>{this.state.totals ? this.state.totals['voo_total'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.AtrasadosInt}</td>
                <td>{this.state.totals ? this.state.totals['atraso_interno'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.AtrasadosExt}</td>
                <td>{this.state.totals ? this.state.totals['atraso_externo'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.Pontualidade}</td>
                <td>{this.state.totals ? this.state.totals['pontualidade_total'] : 0}%</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.PontSemAtrasosExt}</td>
                <td>{this.state.totals ? this.state.totals['pontualidade_ext'] : 0}%</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.PontSemAtrasosInt}</td>
                <td>{this.state.totals ? this.state.totals['pontualidade_int'] : 0}%</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.VooManutencao}</td>
                <td>{this.state.totals ? this.state.totals['mnt'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.VooGiros}</td>
                <td>{this.state.totals ? this.state.totals['giros'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.VooTreinamento}</td>
                <td>{this.state.totals ? this.state.totals['treinamento'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.VooPTBR}</td>
                <td>{this.state.totals ? this.state.totals['ptbr'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.VooOutrosClientes}</td>
                <td>{this.state.totals ? this.state.totals['clientes'] : 0}</td>
            </tr>
            <tr>
                <td>{this.locale.Voos.ListaDeVoos.tabela.VoosComerciais}</td>
                <td>{this.state.totals ? this.state.totals['comerciais'] : 0}</td>
            </tr>
        </tbody>
      </table>
      <hr/>
      <h3 className="page-title">{this.locale.Voos.ListaDeVoos.tituloVoosPara(this.state.date_start, this.state.date_finish)}</h3>
      <hr/>
      {Object.keys(self.state.flights).map(function(base) {
        return (
          <div>
            <h4>{base}</h4>
            <ul>
              {Object.keys(self.state.flights[base]).map(function(k) {
                return (
                  <div>
                    <li>- <strong>{self.state.flights[base][k].aircraft}</strong> <button className="btn btn-sm btn-danger" value={self.state.flights[base][k].id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button></li>
                    {(self.state.flights[base][k].delay_str == "Sim") ?
                      <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Atrasado}:</strong> <span className="label label-danger">{self.state.flights[base][k].delay_str}</span></li> 
                      : <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Atrasado}:</strong> <span className="label label-primary">{self.state.flights[base][k].delay_str}</span></li>
                    }
                    <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.SaidaPrevista}:</strong> {self.state.flights[base][k].scheduled_departure_str}</li>
                    <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.SaidaReal}:</strong> {self.state.flights[base][k].actual_departure_str}</li>
                    {(self.state.flights[base][k].delay > 5) ?
                      <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Atraso}:</strong> <span className="label label-danger">{self.state.flights[base][k].delay_hr}</span></li> 
                      : ""
                    }
                    {(self.state.flights[base][k].justification_ptbr !== null) ?
                      <div>
                        <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.JustificativaPTBR}:</strong> {self.state.flights[base][k].justification_ptbr}</li>
                        <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Motivo}:</strong> {self.state.flights[base][k].reason_ptbr}</li>
                        <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Codigo}:</strong> {self.state.flights[base][k].code}</li>
                      </div>
                      : ""
                    }
                    {(self.state.flights[base][k].justification_omni !== null) ?
                      <div>
                        <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.JustificativaOmni}:</strong> {self.state.flights[base][k].justification_omni}</li>
                        <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Motivo}:</strong> {self.state.flights[base][k].reason}</li>
                        <li>- <strong>{self.locale.Voos.ListaDeVoos.listaVoosPara.Setor}:</strong> {self.state.flights[base][k].session}</li>
                      </div>
                      : ""
                    }
                    <hr/>
                  </div>
                );
              })}           
            </ul>
            <hr/>
          </div>
        );
      })}
    </div>
  </div>
</div>
    );
  }
}

export default FlightsIndex;



// WEBPACK FOOTER //
// ./src/Components/Flights/FlightsIndex.js